import Super from './section-header-input';
import classic from 'ember-classic-decorator';

@classic
export default class SharedQuestionnaireSectionHeaderReview extends Super {}
